import { render, staticRenderFns } from "./list_all_names.vue?vue&type=template&id=fd70e9a6&"
import script from "./list_all_names.vue?vue&type=script&lang=js&"
export * from "./list_all_names.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports